import { ActionForm, type FormSpec } from '@features/ksp-actions/ActionForm';

export interface ActionModalProps {
  form: FormSpec | null;
  busy?: boolean;
  onClose: () => void;
}

export function ActionModal({ form, busy, onClose }: ActionModalProps) {
  if (!form) return null;
  return (
    <ActionForm
      key={form.id ?? form.title}
      spec={form}
      busy={busy ?? false}
      onClose={onClose}
    />
  );
}
